import React from "react";
import classes from "./prizeSection.module.css";
import { useNavigate } from "react-router-dom";

const PrizeSection = ({ prizes }) => {
  const navigate = useNavigate();
  const handleStartCompeting = () => {
    navigate("/artist-next-door-arena/compete");
  };
  return (
    <section className={classes.prizeSection} id="prizes">
      <div className={classes.prizeBackground}>
        <div className={classes.prizeGlow}></div>
      </div>

      <div className={classes.prizeContent}>
        <div className={classes.sectionHeader}>
          <h2 className={classes.sectionTitle}>
            Win <span className={classes.highlight}>Amazing Prizes</span> Every
            Week
          </h2>
          <p className={classes.sectionDescription}>
            Compete in weekly contests and get a chance to win fantastic rewards
            and recognition
          </p>
        </div>

        <div className={classes.prizesContainer}>
          {prizes.map((prize, index) => (
            <div key={index} className={classes.prizeCard}>
              <div className={classes.prizeIcon}>{prize.icon}</div>
              <div className={classes.prizeDetails}>
                <h3 className={classes.prizePlace}>{prize.place}</h3>
                <p className={classes.prizeReward}>{prize.reward}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={classes.additionalPrizes}>
          <div className={classes.additionalPrizeItem}>
            <div className={classes.additionalPrizeIcon}>🔍</div>
            <div className={classes.additionalPrizeText}>
              <h4>Industry Exposure</h4>
              <p>Chance to be discovered by industry professionals</p>
            </div>
          </div>

          <div className={classes.additionalPrizeItem}>
            <div className={classes.additionalPrizeIcon}>🎭</div>
            <div className={classes.additionalPrizeText}>
              <h4>Performance Opportunities</h4>
              <p>Live performance opportunities at major events</p>
            </div>
          </div>

          <div className={classes.additionalPrizeItem}>
            <div className={classes.additionalPrizeIcon}>🎓</div>
            <div className={classes.additionalPrizeText}>
              <h4>Mentorship Programs</h4>
              <p>Learn from the best in the industry</p>
            </div>
          </div>
        </div>

        <div className={classes.callToAction}>
          <button className={classes.ctaButton} onClick={handleStartCompeting}>
            Compete Now
          </button>
          <p className={classes.ctaText}>New contests start every Monday!</p>
        </div>
      </div>
    </section>
  );
};

export default PrizeSection;
